



















































































import { Vue, Component } from 'vue-property-decorator'
import Moment from 'moment'

@Component({
  props: {
    mes: {
      type: Object,
      default: {},
    },
    idFontePagadora: {
      type: String,
      default: '',
    },
  },
})

export default class ComponentRelatorioMensalMes extends Vue {
  getSplitMonth(month) {
    return Moment(month).format('YYYY-MM')
  }

  getSplitStatus(status) {
    switch (status) {
      case 'Não recebido':
        return 'naorecebido'

      case 'Pagamento a menor':
        return 'pagoamenor'

      case 'Pago adiantado':
        return 'pagoadiantado'

      case 'Glosa':
        return 'glosa'

      case 'Pago no prazo previsto':
        return 'pagonoprazo'

      case 'Pago atrasado':
        return 'pagoatrasado'

      default:
        return ''
    }
  }
}
